import { createContext, useContext, ReactNode } from 'react';
import { useCarousel } from '../hooks/carousel/useCarousel';
import { CameraDirection } from '../components/carousel/cameraTagPosition';

// Define the shape of the data the context will provide.
// It's essentially the return type of your useCarousel hook.

export type CarouselContextType = ReturnType<typeof useCarousel>;

export const CarouselContext = createContext<CarouselContextType | null>(null);

export const CarouselProvider: React.FC<{
  children: ReactNode;
  images: any[];
  cameraDirection?: CameraDirection;
}> = ({ children, images, cameraDirection }) => {
  const carouselState = useCarousel(images, cameraDirection);

  return (
    <CarouselContext.Provider value={carouselState}>
      {children}
    </CarouselContext.Provider>
  );
};

// Create a custom hook for easy consumption of the context.
// This is best practice!
export const useCarouselContext = () => {
  const context = useContext(CarouselContext);
  if (!context) {
    throw new Error('useCarouselContext must be used within a CarouselProvider');
  }
  return context;
};
